<template>
  <div class="bg_white mt25">
    <Pageback :backLinkName="'fellowTimesArchive'" />
    <div class="wrap">
      <div class="head-content">
        <div class="thumbnail"><img :src="imagePath + thumbnail" alt=""></div>
        <div class="post-title">
          <h1>{{ title }}</h1>
        </div>
        <div class="post-date">
          <img src="@/assets/images/icon-time.png" alt="">
          <p>{{ date }}</p>
        </div>
      </div>
      <div class="container" v-html="body"></div>
      <!-- <div class="container">
        <div class="thumbnail"><img src="@/assets/images/fanclub/summitmember/birthday01_1024.png" alt=""></div>
        <h2 class="sec_title ab">テストタイトル1</h2>
        <p class="sec_text">テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。テキストが入ります。</p>
      </div> -->
    </div>
  </div>
</template>

<script>
import Pageback from '@/components/common/Pageback';
import FanClub from '@/components/api/fanClub'
import Config from '@/config/config'

export default {
  components: {
    Pageback
  },
  data() {
    return {
      imagePath: Config.APIURL,
      thumbnail: '',
      title: '',
      date: '',
      body: '',
    }
  },
  created() {
    // HEALTH_TOPIC
    FanClub.getDetail(this.$route.params.id).then((val) => {
      console.log(val);
      this.thumbnail = val.thumbnailPath;
      this.title = val.title;
      this.date = val.updateDate;
      this.body = val.body;
    });
  }
}
</script>

<style lang="css" scoped>
/* ----------------------
共通
------------------------- */
>>> img {
  height: auto;
}
body{
  font-size: 14px;
}

/* 改行用 */
>>> .br768on{
  display:none;
}
>>> .br480on{
  display:none;
}
>>> .br375on{
  display:none;
}

/* レスポンシブ時の切り替え用 */
>>> .sp768on{
  display:none;
}
>>> .sp480on{
  display:none;
}
>>> .sp375on{
  display:none;
}
@media screen and (max-width:768px){
  >>> .br768off{
    display:none;
  }
  >>> .sp768off{
    display:none;
  }
  >>> .br768on{
    display:block;
  }
  >>> .sp768on{
    display:block;
  }
}
@media screen and (max-width:480px){
  >>> .br480off{
    display:none;
  }
  >>> .sp480off{
    display:none;
  }
  >>> .br480on{
    display:block;
  }
  >>> .sp480on{
    display:block;
  }
}
@media screen and (max-width:375px){
  >>> .br375off{
    display:none;
  }
  >>> .sp375off{
    display:none;
  }
  >>> .br375on{
    display:block;
  }
  >>> .sp375on{
    display:block;
  }
}

>>> .thumbnail{
  margin-bottom: 20px;
  text-align: center;
}

>>> .post-title,
.post-date{
  padding: 0 20px;
}

>>> >>> .post-title{
  font-size: 6vw;
  margin-bottom: 10px;
}

@media (min-width:641px){
  >>> .post-title{
    font-size: 40px;
  }
}

>>> .post-date{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #c1c1c1;
  font-size: 12px;
}

>>> .post-date img{
  max-width: 15px;
  margin-right: 5px;
}

>>> .container{
  padding: 0 20px;
}

>>> .container p{
  font-size: 16px;
  /* margin: 25px 0; */
  line-height: 1.8;
}

>>> .container h2 {
  color: #6AAFFF;
  font-size: 20px;
  margin-top: 10px;
}

>>> figure {
  margin: 1em 0;
}
</style>



// WEBPACK FOOTER //
// src/views/fanClub/fellowTimes/PostDetail.vue